import React from "react";
import LoginHeader from "./LoginHeader";
import LoginForm from "./LoginForm";
import { Shield } from "lucide-react";

const LoginCard = ({
  credentials,
  newPassword,
  loading,
  oktaLoading,
  error,
  needsPasswordChange,
  showDirectLogin,
  handleSubmit,
  handlePasswordChange,
  handleChange,
  handleOktaLogin,
  toggleDirectLogin,
  setNewPassword,
  isOktaEnabled,
  getOktaConfig,
}) => {
  const oktaConfig = getOktaConfig();

  return (
    <div className="relative w-full max-w-md rounded-2xl shadow-2xl animate-fade-in">
      {/* Panel del formulario */}
      <div className="relative bg-gray-900 rounded-2xl p-8 sm:p-10 flex flex-col justify-center overflow-hidden">
        {/* Decorative circles - naranja */}
        <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#F26522]/20 pointer-events-none" />
        <div className="absolute -bottom-8 -left-8 w-36 h-36 rounded-full bg-[#F26522]/15 pointer-events-none" />

        <LoginHeader />

        <div className="space-y-5">
          {/* Botón principal de Okta */}
          {isOktaEnabled() && (
            <button
              onClick={handleOktaLogin}
              className="w-full bg-gray-600 hover:bg-[#F26522] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-3 disabled:opacity-60 disabled:cursor-not-allowed shadow-lg"
              disabled={oktaLoading || loading}
            >
              {oktaLoading ? (
                <>
                  <span className="animate-spin inline-block w-5 h-5 border-2 border-white/30 border-t-white rounded-full" />
                  <span>Connecting to Okta...</span>
                </>
              ) : (
                <>
                  <Shield size={18} />
                  <span>{oktaConfig.buttonText || "Sign in with Okta"}</span>
                </>
              )}
            </button>
          )}

          {/* Separador */}
          {isOktaEnabled() && (
            <div className="relative">
              <hr className="border-gray-700" />
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gray-900 px-4 text-xs text-gray-400 uppercase tracking-wider">
                or
              </span>
            </div>
          )}

          {/* Toggle login directo o formulario */}
          {isOktaEnabled() && !showDirectLogin ? (
            <button
              type="button"
              onClick={toggleDirectLogin}
              className="w-full text-gray-400 hover:text-gray-200 text-sm transition-colors"
            >
              Use direct login instead
            </button>
          ) : (
            <LoginForm
              credentials={credentials}
              newPassword={newPassword}
              loading={loading}
              error={error}
              needsPasswordChange={needsPasswordChange}
              showDirectLogin={showDirectLogin}
              handleSubmit={handleSubmit}
              handlePasswordChange={handlePasswordChange}
              handleChange={handleChange}
              setNewPassword={setNewPassword}
              toggleDirectLogin={toggleDirectLogin}
              isOktaEnabled={isOktaEnabled}
            />
          )}

          {/* Info corporativa */}
          {isOktaEnabled() && oktaConfig.companyName && (
            <div className="text-center text-sm text-gray-400 bg-gray-800 p-4 rounded-lg border border-gray-700">
              <p className="font-semibold text-gray-200 mb-1">
                {oktaConfig.companyName} Employees
              </p>
              <p className="text-xs">
                {oktaConfig.description ||
                  "Use your corporate credentials to access the portal"}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginCard;
